import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { initialDriver } from '../initialState'

const driverSlice = createSlice({
  name: 'driver',
  initialState: initialDriver,
  reducers: {
    updateLatLngDriver: (state: any, action: PayloadAction<any>) => {
      state.position = { lat: action.payload.lat, lng: action.payload.lng }
    },
  },
})

export const driverAction = driverSlice.actions
export default driverSlice
